import React from 'react'

import { makeTraceDetails, Page } from 'common'
import { ErrorHandler, Header } from 'components'
import { Routes } from 'common/constants'

import { useUnavailableFeature } from '../hooks/useUnavailableFeature'
import { UnavailableFeatureSkeleton } from './UnavailableFeatureSkeleton'
import { UnavailableFeatureView } from './UnavailableFeatureView'

export function UnavailableFeature() {
  const { isActive, content, isLoading, onclick } = useUnavailableFeature()

  if (isLoading) return <UnavailableFeatureSkeleton />

  if (!content) {
    const traceDetails = makeTraceDetails(!!isActive, {
      content: content ?? {},
    })
    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={UnavailableFeature.name}
        goTo={Routes.LEAVE_TO_APP}
      />
    )
  }

  const { details, icon, title, type, button, email } = content

  return (
    <Page>
      <Header title={title} leftIcon={false} />
      <UnavailableFeatureView
        details={details}
        icon={icon}
        title={title}
        type={type}
        button={button}
        email={email}
        onclick={onclick}
      />
    </Page>
  )
}
